import styled from '@emotion/styled'
import { Modal } from 'antd'
import CommonButton from '@/components/common/Button'

export const StyledModal = styled(Modal)`
  .ant-modal-content {
    border-radius: 16px;
    padding: 24px 24px 32px;
  }

  .ant-modal-header {
    border-bottom: none;
    padding: 0;
  }

  .ant-modal-body {
    padding: 0;
  }

  .ant-modal-close {
    display: none;
  }
`

export const Title = styled('div')`
  font-size: 20px;
  font-weight: 600;
  color: #1f1f1f;
`

export const Description = styled('div')`
  font-size: 14px;
  line-height: 20px;
  color: #4b4b4b;
  margin-top: 4px;
`

export const ButtonRow = styled('div')`
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  margin-top: 24px;
`

export const CancelButton = styled(CommonButton)`
  background-color: #ffffff;
  color: #1f1f1f !important;
  border: 1px solid #d9d9d9 !important;
`

export const EditButton = styled(CommonButton)`
  background-color: #009400;
  color: #ffffff !important;
  border: 1px solid #009400 !important;
`
